/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import EndProjectForm from './EndProjectForm/EndProjectForm';
import EndProjectSuccess from './EndProjectSuccess/EndProjectSuccess';
import EndProjectError from './EndProjectError/EndProjectError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  project: Object,
  actionDrawerStore: TypeActionDrawerStore,
  projectDetailsStore: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class EndProject extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore, projectDetailsStore }: TypeProps = this.props;
    const project: Object = this.props.project;
    const fields: Array<Object> = [
      {
        name: 'endProjectForm',
        label: t('general:actions.end_project'),
        title: 'End Project',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_ending_project'),
            rules: 'required|string',
            value: '',
            type: 'select',
            placeholder: t('general:placeholders.select_reason'),
            options: [
              {
                id: 1,
                label: t('general:reasons.options.project_complete'),
              },
              {
                id: 2,
                label: t('general:reasons.options.project_cancelled'),
              },
              {
                id: 3,
                label: t('general:reasons.options.project_on_hold'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onInit(data: Object) {
        if (!(project && project.trading_account)) {
          projectDetailsStore.clearDetails();
          projectDetailsStore.loadProjectDetails(project.id);
        }
      },
      onSuccess(data: Object) {
        const { reason }: Object = data.values().endProjectForm;

        actionDrawerStore.endProject(project.id, {
          end_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.end_project'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props.project;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.end_project')} />
          <EndProjectError response={actionDrawerStore.errorResponse} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.archived}`}>
          <ActionDrawerHeader title={t('general:actions.end_project')} />
          <EndProjectSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.end_project')} />
        <EndProjectForm project={project} form={this.createForm()} />
      </div>
    );
  }
}
